import * as actionTypes from "../actionTypes.js";

const initialState = {
  systemConfigList: null,

  uploadedFilesList: null,
  currenciesList: null,

  errorLogsList: null,
  errorLog: null,
  errorStats: null,
};

const businessReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_SYSTEM_CONFIG_BIZ:
      return { ...state, systemConfigList: action.payload };

    case actionTypes.GET_UPLOADED_FILES_BIZ:
      return { ...state, uploadedFilesList: action.payload };
    case actionTypes.GET_CURRENCIES_BIZ:
      localStorage.setItem("CurrencyList", JSON.stringify(action.payload.records));
      return { ...state, currenciesList: action.payload };

    case actionTypes.GET_ERROR_LOGS_BIZ:
      return { ...state, errorLogsList: action.payload };
    case actionTypes.GET_ERROR_LOG_BIZ:
      return { ...state, errorLog: action.payload };
    case actionTypes.GET_ERROR_STATS_BIZ:
      return { ...state, errorStats: action.payload };
      

    case actionTypes.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default businessReducer;